<dx-switch [(value)]="swithTheme" (valueChange)="modelChanged()"></dx-switch>